import { render, staticRenderFns } from "./SettingsWidget.vue?vue&type=template&id=650c4cf2&scoped=true&"
import script from "./SettingsWidget.vue?vue&type=script&lang=ts&"
export * from "./SettingsWidget.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsWidget.vue?vue&type=style&index=0&id=650c4cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650c4cf2",
  null
  
)

export default component.exports